import { createI18n } from 'vue-i18n'

const i18n = createI18n({
    locale: 'ua',
    fallbackLocale: 'en',
    messages: {
      en: {
        myHome: {
            "accessesTitle": "Your accesses",
            "noEntrances": "No entrances are assigned to this account.",
            "faceIdentification": "Face recognition",
            "cardsIdentification": "Card or key fob",
            "plateIdentification": "License plate",
            "carGate": "Car gate",
            "videoIntercom": "Video intercom",
            "chipIntercom": "Intercom without video",
            "videoDoorbells": "Video doorbells",
            "unsavedTitle": "Unsaved changes",
            "keepEditing": "Keep editing",
            "leaveWithoutSaving": "Leave without saving",
            "enterName": "Enter name",
            "enterVehicleName": "Enter vehicle name",
            "choosePhoto": "Choose photo for profile {number}",
            "plateNumber": "License plate {number}",
            "removeItem": "Remove item {number}",
            "save": "Save",
            "saving": "Saving…",
            "plateLockTitle": "Confirm license plate change",
            "plateLockConfirm": "After saving, the license plate number cannot be changed or removed for 24 hours. The vehicle name can be changed without restrictions.",
            "plateLockedHours": "Changes locked for {count} h",
            "plateLockedMinutes": "Changes locked for {count} min",
            "plateLockError": "A license plate is locked. Its number cannot be changed and it cannot be removed until the lock expires.",

            "discardChanges": "You have unsaved changes. Leave this page and lose your changes?",
            "limitExceeded": "The available limit has been reached. Remove an item before saving.",
            "invalidName": "Names must not exceed 255 characters.",
            "photoRequired": "Choose a photo for each named profile.",
            "photoSize": "Use JPG, PNG, WebP, HEIC/HEIF, AVIF, GIF, BMP or TIFF, up to 10 MB and 25 megapixels per image, 20 MB total.",
            "photoSelected": "Selected: {name}. The photo will appear after saving.",
            "photoUploadUnavailable": "The server could not accept this photo's size. Please contact support.",
            "photoSaveInvalid": "Could not save your photos. Check the selected images and your available profile limit.",
            "invalidPlate": "Enter valid, unique license plates (up to 20 letters, numbers or hyphens).",
            "saveInvalid": "Could not save. Check the entries and your available limit. A plate may already be registered.",
            "saveFailed": "Could not save your changes. Please try again.",

            "loading": "Loading your home…",
            "retry": "Try again",
            "building": "Building",
            "address": "Address",
            "myAccesses": "My accesses",
            "biometric": "Biometric access",
            "photoDescription": "Face profiles available for your apartment. Limit: {limit}.",
            "profile": "Profile {number}",
            "addProfile": "Add photo",
            "noPhotos": "No profiles available.",
            "photoUnavailable": "Profile photo unavailable",
            "edit": "Edit",
            "vehicles": "Vehicles",
            "vehicleDescription": "License plates with access through the barriers. Total - {limit}.",
            "vehicle": "Vehicle {number}",
            "addVehicle": "Add vehicle",
            "noAccess": "Home access is unavailable for this account.",
            "unavailable": "Could not load your home. Please try again.",
            "ambiguous": "More than one home is linked to this account. Please contact support."
        },
        loginPage: {
            login: 'login',
            password: 'password'
        },
        mainPage: {
            internetBlockAlert: 'Internet will be blocked. To continue using the service, please make a payment',
            financeHeader: 'FINANCE',
            outlays: 'write-offs',
            myPaymentsButton: 'My payments',
            payButton: 'Pay',
            myHomeButton: 'My Home',
            servicesHeader: 'SERVICES'
        },
        tariffSlider: {
            speedValue: 'Mbit/s',
            price: 'balance',
            activeTo: 'active to',
            currency: 'UAH',
            channels: 'channels'
        },

        mounthes: {
            january: 'january',
            february: 'february',
            march: 'march',
            april: 'april',
            may: 'may',
            june: 'june',
            july: 'july',
            august: 'august',
            september: 'september',
            october: 'october',
            november: 'november',
            december: 'december'
        },

        mounthesMini: {
            january: 'jan',
            february: 'feb',
            march: 'mar',
            april: 'apr',
            may: 'may',
            june: 'jun',
            july: 'jul',
            august: 'aug',
            september: 'sep',
            october: 'oct',
            november: 'nov',
            december: 'dec'
        },

        barChart: {
            paid: 'Paid'
        },

        specials: {
            backButton: 'back'
        },

        profileSelectingPage: {
            profilesHeader: 'profiles',
            accept: 'Apply'
        },

        allProfilesPage: {
            addProfileButton: 'Add profile',
            exit: 'Exit'
        },

        addProfilePage: {
            enterLoginLabel: 'Enter login',
            enterPasswordLabel: 'Enter password',
            ifDataCorrect: 'if data is correct,',
            pressAddProfile: 'press "Add"',
            addButton: 'Add'
        },

        contactPage: {
            contactsHeader: 'contacts',
            town: 'Uzhhorod,',
            street: 'Bohdan Khmelnytsky Square, 2B',
            workingScheduleHeader: 'WORKING SCHEDULE',
        },

        notificationPage: {
            messagesHeader: 'messages',
        },

        aboutMePage: {
            header: 'about me',
            surname: 'surname',
            name: 'name',
            address : 'address',
            phone: 'phone',
            password: 'password',
            change: 'Change',
            update: 'Update',
            settingHeader: 'settings',
            cardAdded: 'Card added',
            internetAutoWriteOff: 'INTERNET auto write-off',
            tvAutoWriteOff: 'TV auto write-off',
            pushAlerts: 'PUSH-alerts in the app',
            telegramAlerts: 'Telegram alerts',
            contractWithUzhnet: 'Contract with Uzhnet',
            internetParameterMeasurementProtocol: 'Internet parameter measurement protocol',
            appLang: 'Language'
        },

        deleteProfilePage: {
            trulyWantDelete: 'do you really want',
            profileFromApp: 'to delete profile?',
            deleteButton: 'Delete'
        },

        financePage: {
            header: 'FINANCE',
            date: 'date',
            sum: 'amount',
            tariff: 'tariff',
            period: 'range',
            method: 'method',
            speed: 'Mbit/s',

            balance: 'balance',
            cabinet: 'cabinet',
            cashbox: 'cashbox'
        },

        selectPaymentType: {
            header: '',
            fillBalanceHeader: '',
            fillBalancePlate: '',
            oncePayment: '',
        },

        selectPaymentType: {
            header: 'payment',
            fillBalanceHeader: 'add funds to balance',
            fillBalancePlate: 'FILL BALANCE',
            oncePayment: 'make a one-time payment',
            or: 'or',
            writeOffBalance: 'write off balance'
        },

        addBalancePage: {
            enterTheAmount: 'enter the amount,',
            whichYouWantAddToBalance: 'which you want to add to the balance',
            next: 'Next'
        },

        paymentSuccessPage: {
            alertAboutAutoWriteOff: 'Since auto-renewal is disabled in your settings, the validity of services will not extend automatically. You need to click "Pay for services", select Internet or TV, specify the tariff/package and period, and deduct funds from the balance.'
        },

        selectTariffPage: {
            header: 'tariffs',
            speed: 'Mbit/s',
            channels: 'channels',

            priceMonth: 'm',
            priceDay: 'd',
            currency: 'UAH',
        },

        selectedTariff: {
            header: 'selected tariff',
            speed: 'Mbit/s',
            channels: 'channels',
            priceMonth: 'm',
            priceDay: 'd',
            currency: 'UAH',
            payButton: 'Next',
            selectPeriod: 'Select period',

            oneDay: 'day',
            moreDays: 'days',

            oneMonth: 'month',
            moreMonthes: 'months',
        },

        paymentPage: {
            payment: 'payment',
            speed: 'Mbps',
            channels: 'channels',
            priceMonth: 'month',
            priceDay: 'day',
            currency: 'UAH',

            averageBalance: '',
            moreDays: 'days',
            choosedPeriod: 'Chosen period',

            endOfTariff: 'TARIFF END',
            priceHeader: 'COST',
            choosedTariffHeader: 'CHOSEN TARIFF',

            writeoffBalanceButton: 'Deduct from balance',
            notFundsOnBalance: 'insufficient funds on balance',
            oneTimePayment: 'One-time payment',
            addTariff: 'Activate tariff'
        }
      },
      ua: {
        myHome: {
            "accessesTitle": "ваші доступи",
            "noEntrances": "Для цього облікового запису немає доступних входів.",
            "faceIdentification": "Розпізнавання обличчя",
            "cardsIdentification": "Картка або брелок",
            "plateIdentification": "Номерний знак автомобіля",
            "carGate": "Автомобільні ворота",
            "videoIntercom": "Відеодомофон",
            "chipIntercom": "Домофон без відео",
            "videoDoorbells": "ВІДЕОДОМОФОНИ",
            "unsavedTitle": "Незбережені зміни",
            "keepEditing": "Продовжити редагування",
            "leaveWithoutSaving": "Вийти без збереження",
            "enterName": "введіть ім’я",
            "enterVehicleName": "введіть назву авто",
            "choosePhoto": "Вибрати фото профілю {number}",
            "plateNumber": "Номерний знак авто {number}",
            "removeItem": "Видалити запис {number}",
            "save": "зберегти",
            "saving": "Збереження…",
            "plateLockTitle": "Підтвердьте зміну номерного знака",
            "plateLockConfirm": "Після збереження номер не можна буде змінити або видалити протягом 24 годин. Назву автомобіля можна змінювати без обмежень.",
            "plateLockedHours": "Зміни заблоковані на {count} год",
            "plateLockedMinutes": "Зміни заблоковані на {count} хв",
            "plateLockError": "Номерний знак заблоковано. Змінити номер або видалити запис можна після завершення блокування.",

            "discardChanges": "У вас є незбережені зміни. Вийти зі сторінки та втратити зміни?",
            "limitExceeded": "Досягнуто доступного ліміту. Видаліть запис перед збереженням.",
            "invalidName": "Ім’я або назва не повинні перевищувати 255 символів.",
            "photoRequired": "Виберіть фото для кожного профілю з іменем.",
            "photoSize": "Виберіть JPG, PNG, WebP, HEIC/HEIF, AVIF, GIF, BMP або TIFF до 10 МБ і 25 мегапікселів на фото, до 20 МБ загалом.",
            "photoSelected": "Вибрано: {name}. Фото зʼявиться після збереження.",
            "photoUploadUnavailable": "Сервер обмежує розмір завантаження фото. Зверніться до підтримки.",
            "photoSaveInvalid": "Не вдалося зберегти фото. Перевірте вибрані зображення та доступний ліміт профілів.",
            "invalidPlate": "Введіть коректні, унікальні номерні знаки (до 20 літер, цифр або дефісів).",
            "saveInvalid": "Не вдалося зберегти. Перевірте записи та доступний ліміт. Номер авто може бути вже зареєстрований.",
            "saveFailed": "Не вдалося зберегти зміни. Спробуйте ще раз.",

            "loading": "Завантаження даних вашого дому…",
            "retry": "Спробувати ще раз",
            "building": "ЖК",
            "address": "адреса",
            "myAccesses": "Мої доступи",
            "biometric": "біометричний доступ",
            "photoDescription": "Профілі облич, які доступні для вашої квартири. Всього – {limit}.",
            "profile": "профіль {number}",
            "addProfile": "Додати фото",
            "noPhotos": "Профілі відсутні.",
            "photoUnavailable": "Фото профілю недоступне",
            "edit": "редагувати",
            "vehicles": "автомобілі",
            "vehicleDescription": "Номерні знаки ваших авто, які мають доступ для проїзду через шлагбауми. Всього – {limit}.",
            "vehicle": "авто {number}",
            "addVehicle": "Додати авто",
            "noAccess": "Доступ до дому для цього облікового запису відсутній.",
            "unavailable": "Не вдалося завантажити дані дому. Спробуйте ще раз.",
            "ambiguous": "До облікового запису прив’язано декілька домів. Зверніться до підтримки."
        },
        loginPage: {
            login: 'логін',
            password: 'пароль'
        },
        mainPage: {
            internetBlockAlert: 'Інтернет буде заблоковано. Для подальшого користування послугою - проведіть оплату',
            financeHeader: 'ФІНАНСИ',
            outlays: 'списання',
            myPaymentsButton: 'Мої оплати',
            payButton: 'Сплатити',
            myHomeButton: 'Мій дім',
            servicesHeader: 'ПОСЛУГИ'
        },
        tariffSlider: {
            speedValue: 'Мбіт/с',
            price: 'баланс',
            activeTo: 'активний до',
            currency: 'грн',
            channels: 'каналів'
        },

        addProfilePage: {
            enterLoginLabel: 'введіть логін, який хочете додати',
            enterPasswordLabel: 'введіть пароль до логіну:',
            ifDataCorrect: 'якщо дані вірні,',
            pressAddProfile: 'натисніть додати',
            addButton: 'Додати'
        },

        mounthes: {
            january: 'січень',
            february: 'лютий',
            march: 'березень',
            april: 'квітень',
            may: 'травень',
            june: 'червень',
            july: 'липень',
            august: 'серпень',
            september: 'вересень',
            october: 'жовтень',
            november: 'листопад',
            december: 'грудень'
        },
        mounthesMini: {
            january: 'січ',
            february: 'лют',
            march: 'бер',
            april: 'кві',
            may: 'тра',
            june: 'чер',
            july: 'лип',
            august: 'сер',
            september: 'вер',
            october: 'жов',
            november: 'лис',
            december: 'гру'
        },

        barChart: {
            paid: 'Сплачено'
        },

        specials: {
            backButton: 'назад'
        },

        profileSelectingPage: {
            profilesHeader: 'профілі',
            accept: 'Застосувати'
        },

        allProfilesPage: {
            addProfileButton: 'Додати профіль',
            exit: 'Вийти'
        },

        contactPage: {
            contactsHeader: 'контакти',
            town: 'м. Ужгород,',
            street: 'пл. Б. Хмельницького, 2Б',
            workingScheduleHeader: 'ГРАФІК РОБОТИ',
        },

        notificationPage: {
            messagesHeader: 'повідомлення',
        },

        aboutMePage: {
            header: 'про мене',
            surname: 'прізвище',
            name: 'ім\'я',
            address : 'адреса',
            phone: 'номер',
            password: 'пароль',
            change: 'Редагувати',
            update: 'Оновити',
            settingHeader: 'налаштування',
            cardAdded: 'Прив\'язка карти',
            internetAutoWriteOff: 'INTERNET автосписання',
            tvAutoWriteOff: 'TV автосписання',
            pushAlerts: 'PUSH-сповіщення у додатку',
            telegramAlerts: 'Сповіщення у Telegram',
            contractWithUzhnet: 'Договір ТОВ "УЖНЕТ"',
            internetParameterMeasurementProtocol: 'Протокол вимірювань параметрів інтернет',
            appLang: 'Мова додатку'
        },

        deleteProfilePage: {
            trulyWantDelete: 'дійсно бажаєте видалити',
            profileFromApp: 'профіль з додатку?',
            deleteButton: 'Видалити'
        },

        financePage: {
            header: 'ФІНАНСИ',
            date: 'дата',
            sum: 'сума',
            tariff: 'тариф',
            period: 'період',
            method: 'метод',
            speed: 'Мбіт/с',

            balance: 'баланс',
            cabinet: 'кабінет',
            cashbox: 'каса'
        },

        selectPaymentType: {
            header: 'сплатити',
            fillBalanceHeader: 'внести кошти на баланс',
            fillBalancePlate: 'ПОПОВНИТИ БАЛАНС',
            oncePayment: 'провести разову оплату',
            or: 'або',
            writeOffBalance: 'списати з балансу'
        },

        addBalancePage: {
            enterTheAmount: 'введіть суму,',
            whichYouWantAddToBalance: 'яку бажаєте внести на баланс',
            next: 'Далі'
        },

        paymentSuccessPage: {
            alertAboutAutoWriteOff: 'Оскільки у тебе в налаштуваннях автосписання відключене, то термін дії послуг самостійно не подовжиться. Тобі потрібно натиснути "Сплатити послуги", обрати Internet або TV, вказати тариф/пакет і період та списати кошти з балансу.'
        },

        selectTariffPage: {
            header: 'тарифи',
            speed: 'Мбіт/с',
            channels: 'каналів',
            priceMonth: 'міс',
            priceDay: 'день',
            currency: 'грн',
        },

        selectedTariff: {
            header: 'вибір тарифу',
            speed: 'Мбіт/с',
            channels: 'каналів',
            priceMonth: 'міс',
            priceDay: 'день',
            currency: 'грн',
            payButton: 'Далі',
            selectPeriod: 'Виберіть період',

            oneDay: 'день',
            moreDays: 'днів',

            oneMonth: 'місяць',
            moreMonthes: 'місяців',
        },

        paymentPage: {
            payment: 'оплата',
            speed: 'Мбіт/с',
            channels: 'каналів',
            priceMonth: 'міс',
            priceDay: 'день',
            currency: 'грн',

            averageBalance: 'загальний баланс',
            moreDays: 'днів',
            choosedPeriod: 'обраний період',

            endOfTariff: 'ЗАКІНЧЕННЯ ТАРИФУ',
            priceHeader: 'ВАРТІСТЬ',
            choosedTariffHeader: 'ОБРАНОГО ТАРИФУ',

            writeoffBalanceButton: 'Списати з балансу',
            notFundsOnBalance: 'недостатньо коштів на балансі',
            oneTimePayment: 'Разова оплата',
            addTariff: 'Підключити тариф'
        }
      }
    }
})

export default i18n;
